export default __webpack_public_path__ + "static/media/Champagne Nicolas Feuillatte - Logo2.876a07f7.png";